import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";

const Auth = () => {
	const [user, setUser] = useState({
		email: "",
		password: "",
		role: "",
	});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const loginHandler = async (e) => {
		e.preventDefault();
		const { email, password, role } = user;
		if (email.length < 1 || password.length < 1 || role.length < 1) {
			alert("Please fill all the details");
			return;
		}
		setLoading(true);

		try {
			let response = await axios.post(`/api/auth/${role}/login`, {
				email,
				password,
			});
			if (response.status === 200) {
				localStorage.setItem(
					"nguser",
					JSON.stringify(response.data.user),
				);
				navigate(`/${role}`);
			}
		} catch (error) {
			alert("Login failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<main className="w-screen h-screen flex flex-col justify-center items-center text-center">
			<form className="text-white" onSubmit={loginHandler}>
				<div className="h-32">
					<img src="/full_logo.png" className="h-full" />
				</div>

				<div className="flex justify-center flex-col items-start mt-10">
					<label htmlFor="email" className="mb-1">
						Email
					</label>
					<input
						type="email"
						name="email"
						value={user.email}
						onChange={(e) =>
							setUser({ ...user, email: e.target.value })
						}
						className="px-3 py-2 border rounded-md border-gray-300 mb-5 w-full bg-black"
						placeholder="me@ngcoaching.com"
					/>

					<label htmlFor="password" className="mb-1">
						Password
					</label>
					<input
						type="password"
						name="password"
						value={user.password}
						onChange={(e) =>
							setUser({ ...user, password: e.target.value })
						}
						className="px-3 py-2 w-full border rounded-md border-gray-300 mb-5 bg-black"
						placeholder="••••••••••"
					/>

					<label htmlFor="role" className="mb-1">
						I am
					</label>
					<select
						name="role"
						value={user.role}
						onChange={(e) =>
							setUser({ ...user, role: e.target.value })
						}
						className="px-2 py-2 border rounded-md border-gray-300 mb-5 w-full cursor-pointer bg-black"
					>
						<option value="" disabled>
							Select your role
						</option>
						<option value="admin">Admin</option>
						<option value="coach">Coach</option>
						<option value="player">Player</option>
					</select>
				</div>

				<button
					type="submit"
					className="w-full my-4 bg-orange-600 font-semibold rounded-md py-4 text-white hover:bg-orange-600/80 cursor-pointer"
				>
					{loading ? (
						<div className="flex justify-center items-center cursor-not-allowed">
							<svg
								class="text-gray-300 animate-spin"
								viewBox="0 0 64 64"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
							>
								<path
									d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
									stroke="currentColor"
									stroke-width="5"
									stroke-linecap="round"
									stroke-linejoin="round"
								></path>
								<path
									d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
									stroke="currentColor"
									stroke-width="5"
									stroke-linecap="round"
									stroke-linejoin="round"
									class="text-gray-900"
								></path>
							</svg>
							<p className="ml-4">Loading</p>
						</div>
					) : (
						"Sign in"
					)}
				</button>
			</form>
			<div className="flex">
				I am a
				<div
					className="font-bold ml-2 cursor-pointer"
					onClick={() => navigate("/family")}
				>
					Famiy Member
				</div>
			</div>
		</main>
	);
};

export default Auth;
